import km from 'keymirror'
import _ from 'underscore'

// TMR ==> ToManyRequests
export default _.extend({
  ORDER_TYPE_IS_GROUP: 2,

  ORDER_CARDDELAY_SUPPLIERID: 1,
  ORDER_PRODUCT_TYPE_CARDDELAY: 7, //卡延期商品
  ORDER_PRODUCT_TYPE_EXAMINE: 11, //体检商品
  ORDER_PRODUCT_TYPE_PERFORM_TICKET: 16, //演出票
  //订单号类型
  ORDER_DETAIL_TYPE_ORDERNUM: 1, //订单号
  ORDER_DETAIL_TYPE_PAYNUM: 2, //支付号

  // 发货类型
  ORDER_DELIVERY_TYPE_IS_DELIVERY: 0, // 无特定发货动作
  ORDER_DELIVERY_TYPE_IS_SELF_LIFTING: 20, // 门店自提
  ORDER_DELIVERY_TYPE_IS_MERCHANT_DELIVERY: 24, // 门店配送

  // 业务订单类型
  ORDER_BUSINESS_TYPE_IS_NORMAL: 0, // 普通订单
  ORDER_BUSINESS_TYPE_IS_ENTERTISE: 1, // 企业订单
  ORDER_BUSINESS_TYPE_IS_EXAMINE: 2, // 体检订单
  ORDER_BUSINESS_TYPE_IS_GIFT: 3, // 礼物订单
  ORDER_BUSINESS_TYPE_IS_WELFARE_CARD_PRODUCT: 4, // 礼包卡兑换商品（档位券）
  ORDER_BUSINESS_TYPE_IS_COURSE: 5, // 在线课程订单

  // 订单状态orderStatus
  ORDER_STATUS_WAIT_PAY: 0, // 等待支付
  ORDER_STATUS_IS_CANCEL_BY_USER: 2, // 用户取消
  ORDER_STATIS_IS_INVALID: 3, // 订单失效（支付超时）
  ORDER_STATUS_IS_HAD_DELIVERY: 4, // 已发货
  ORDER_STATUS_IS_WAIT_DELIVERY: 8, // 等待发货
  ORDER_STATUS_IS_WAIT_RECEIVED: 11, // 等待收货
  ORDER_STATUS_IS_FINISH: 13, // 已完成
  ORDER_STATUS_IS_CLOSED: 14, // 交易关闭

  // 订单类型orderType
  // 订单类型 0：普通订单 1：换货订单 2:团购订单 3：团购换货 4：集配订单 5:拼团子订单（不单独发物流） 6：拼团主订单 7:体检订单
  ORDER_TYPE_IS_NORMAL: 0,

  // 刷新提醒类型optType
  RFRESH_TYPE_RFRESH_STATUS: 1, // 手动刷新订单状态
  RFRESH_TYPE_REMIND_DELIVERY: 2, // 提醒发货


  // 订单sku商品类型
  ORDER_SKU_PRODUCT_TYPE__NORMAL: 0, // 普通商品
  ORDER_SKU_PRODUCT_TYPE__COMBIANTIONGOODS_MAIN: 1, // 组合商品-主商品
  ORDER_SKU_PRODUCT_TYPE__COMBIANTIONGOODS_CHILD: 2, // 组合商品-子商品

  // 包裹类型
  PACKAGETYPE_SINGLE: 0, // 单包裹 （单物流）
  PACKAGETYPE_MUTIL: 1, // 多包裹（多物流）

}, km({

  ORDER_GET_ALL_SUCCESS: null,
  ORDER_GET_ALL_ERROR: null,
  ORDER_GET_ALL_EMPTY: null,
  ORDER_GETTER_ALL: null,

  ORDER_GET_DETAIL_SUCCESS: null,
  ORDER_GET_DETAIL_ERROR: null,
  ORDER_GETTER_DETAIL: null,

  ORDER_CANCEL_SUCCESS: null,
  ORDER_CANCEL_ERROR: null,
  // ORDER_GETTER_CANCEL_STATUS: null,

  DELIVERY_GET_CONFIRM_SUCCESS: null,
  DELIVERY_GET_CONFIRM_ERROR: null,
  // DELIVERY_GETTER_STATUS: null
  ORDER_GET_RECOMMEND_LIST_SUCCESS: null,
  ORDER_GET_RECOMMEND_LIST_ERROR: null,
  ORDER_GET_RECOMMEND_LIST_EMPTY: null,
  ORDER_GETTER_RECOMMEND_LIST: null,

  ORDER_CHECK_PRODUCT_STATUS_SUCCESS: null,
  ORDER_CHECK_PRODUCT_STATUS_ERROR: null,
  ORDER_GETTER_PRODUCT_STATUS_LIST: null,

  ORDER_GET_DELIVERY_SUCCESS: null,
  ORDER_GET_DELIVERY_ERROR: null,


  ORDER_OLD_GET_DETAIL_SUCCESS: null,
  ORDER_OLD_GET_DETAIL_ERROR: null,

  ORDER_GET_ALL_MORE_EMPTY: null,
  ORDER_GET_ALL_MORE_SUCCESS: null,
  ORDER_GET_ALL_MORE_ERROR: null,

  ORDER_GETTER_GET_ORDER_ACTIVE_INFO: null,
  ORDER_GETORDERSIMPLE_SUCCESS: null,
  ORDER_GETORDERSIMPLE_ERROR: null,

  ORDER_GET_USERINVOICE_SUCCESS: null,
  ORDER_GET_USERINVOICE_ERROR: null,

  ORDER_SET_ORDERINVOICE_SUCCESS: null,
  ORDER_SET_ORDERINVOICE_ERROR: null,

  ORDER_GET_ORDER_INVOICE_DETAIL_SUCCESS: null,
  ORDER_GET_ORDER_INVOICE_DETAIL_ERROR: null,

  ORDER_DELETE_SUCCESS: null,
  ORDER_DELETE_ERROR: null,
    /* yeoman-template-point-1 */
}))
